var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-modal', {
    attrs: {
      "id": "personalized-quote-modal",
      "size": _vm.currentStep === 0 ? 'lg' : 'xl',
      "centered": ""
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "close-btn"
    },
    on: {
      "click": _vm.closePersonalizedModal,
      "hide": _vm.closePersonalizedModal
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _vm.currentStep === 0 ? _c('BasicDetails') : _vm._e(), _vm.currentStep === 1 ? _c('PlanSelection', {
    attrs: {
      "modal-heading": _vm.planSelectionHeading,
      "quote-type": "individual"
    }
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }